import { useRef } from 'react';

/**
 * How many times `values` changed since the first render (Object.is per
 * item). Used to key a query so it starts over whenever its inputs change,
 * even when they change back to an earlier combination.
 */
export const useChangeCount = (values: readonly unknown[]): number => {
  const ref = useRef({ values, count: 0 });
  const previous = ref.current.values;
  const changed =
    previous.length !== values.length ||
    values.some((value, index) => !Object.is(value, previous[index]));
  if (changed) {
    ref.current = { values, count: ref.current.count + 1 };
  }
  return ref.current.count;
};
